import React from "react";
import { Link } from "react-router-dom";
import { Bird } from "lucide-react";
import { siteData } from "../mock";

const Footer = () => {
  const { footer, brand } = siteData;
  return (
    <footer className="bg-[#1f2a36] text-white/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col sm:flex-row items-center justify-between gap-5">
        <Link to="/" className="flex items-center gap-2">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 border border-white/15">
            <Bird className="h-5 w-5 text-[#cfe7f8]" />
          </span>
          <span className="ht-display text-base text-white">{brand.shortName}</span>
        </Link>
        <p className="text-xs sm:text-sm text-white/60 text-center">
          {footer.legal}
        </p>
        <div className="flex items-center gap-5">
          {footer.links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className="text-sm text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
